import { api } from '@/shared/api/client-api'
import { API_END_POINTS } from '@/shared/api/end-points'
import { GetTaskHypothesisRecommendationsParams } from '@/shared/api/end-points/hypothesis'

export interface HypothesisRecommendation {
  description: string
  premise: string
  expected_result: string
  script: string
  channels: string
  planing_result: number
  mark: {
    id: number
    name: string
  }
  mark_type: {
    id: number
    name: string
    single: string
    multiple: string
    given: string
  }
  kind: {
    id: number
    name: string
  }
  tool: {
    id: number
    name: string
  }
  priority: {
    id: number
    name: string
  }
}

const gettaskrecommendations = async (params: GetTaskHypothesisRecommendationsParams) => {
  return await api.json<HypothesisRecommendation[]>(API_END_POINTS.hypothesis.getTaskHypothesisRecommendations(params))
}

export default gettaskrecommendations
